import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './shared/SectionHeading';
const faqs = [{
  q: 'Kako funkcioniše proces posredovanja?',
  a: 'Nakon prvog kontakta analiziramo potrebe vaše porodice, predlažemo provjerene kandidate i organizujemo njegu — uz podršku tokom cijelog trajanja angažmana.'
}, {
  q: 'Da li su njegovatelji provjereni?',
  a: 'Da. Svaki njegovatelj i njegovateljica prolaze kroz detaljnu selekciju i provjeru referenci kako bismo garantovali sigurnost i kvalitet.'
}, {
  q: 'Nudite li 24-satnu njegu?',
  a: 'Nudimo. Organizujemo cjelodnevnu kućnu njegu uz stalnu prisutnost, kao i pouzdanu zamjenu njegovatelja kada je potrebno.'
}, {
  q: 'U kojim područjima pružate usluge?',
  a: 'Bazirani smo u Tuzli, a sarađujemo sa porodicama i kandidatima iz regiona te zemalja Evropske unije.'
}, {
  q: 'Koliko brzo možete organizovati njegu?',
  a: 'U većini slučajeva njegu organizujemo vrlo brzo. Javite nam se i pronaći ćemo najbolje rješenje u najkraćem mogućem roku.'
}, {
  q: 'Kako se određuje cijena usluge?',
  a: 'Cijena zavisi od vrste i obima njege. Nakon razgovora o vašim potrebama pripremamo transparentnu i jasnu ponudu bez skrivenih troškova.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="pitanja" className="relative w-full bg-cream py-20 lg:py-28" data-id="element-95">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-96">
        <SectionHeading eyebrow="Česta pitanja" title="Odgovori na vaša pitanja" subtitle="Sve što trebate znati prije nego što nam se javite." data-id="element-97" />

        <div className="mt-12 space-y-4" data-id="element-98">
          {faqs.map((item, i) => {
          const isOpen = open === i;
          return <motion.div key={item.q} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.4,
            delay: i * 0.05
          }} className={`overflow-hidden rounded-2xl border bg-white transition-colors ${isOpen ? 'border-gold/40 shadow-glass' : 'border-transparent'}`} data-id="element-99">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-100">
                  <span className="font-display text-lg font-semibold text-ink" data-id="element-101">
                    {item.q}
                  </span>
                  <motion.span animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.3
              }} className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${isOpen ? 'bg-gold-gradient text-white' : 'bg-cream text-gold-dark'}`} data-id="element-102">
                    <PlusIcon className="h-4 w-4" data-id="element-103" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false} data-id="element-104">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: [0.22, 1, 0.36, 1]
              }} data-id="element-105">
                      <p className="px-6 pb-6 text-base leading-relaxed text-muted" data-id="element-106">
                        {item.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}